  <nb-card *ngIf="!loading && !formHidden" >
           <nb-card-header>
                
 <div style="display:flex; width:100%">
                <span style="margin-right:20px;">Введіть суму UAH</span>   
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>  
                </div>
           </nb-card-header>
           	<nb-card-body  style="">
	 	

		<div><input nbInput  type="number" [(ngModel)]="price" /> </div>

		<div style="margin-top:15px; display:flex">
			<div style="margin:auto; display:flex">
			<button nbButton status="primary" [disabled]="price < 1" (click)="pay()">Перейти до оплати</button>

			</div>
			</div>
		 
 
        	</nb-card-body> 
 </nb-card> 

 
    <div *ngIf="loading" style=" position:fixed; z-index: 7777; width:100%; height:100%; top:0; left: 0; display: flex; ">
    <div style="display: flex; margin: auto;"> 
	 
         <app-loader></app-loader>
     </div>
    </div> 
 
